export default 'tizen';
